'use client';

import { useEffect } from 'react';

import { type EventTypes } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/modules/storage';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  event: EventTypes;
  params?: Record<string, unknown>;
  options?: {
    baseEventOverrides?: Record<string, unknown>;
    handleRequestFailure?: (eventData: Record<string, unknown>) => void;
  };
  /** When provided, the event will only be sent once per session (survives WebView page reloads) */
  dedupKey?: string;
};

/* This component can be used in server component pages to send AT events */
export function SendATEvent({ event, params, options, dedupKey }: Props) {
  const [_, currentUser] = useCurrentUser();
  const userId = currentUser?.id;
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId,
  });

  useEffect(() => {
    if (dedupKey && getSessionStorageItem(dedupKey)) {
      return;
    }

    sendActivityTrackerEvent(event, params, options);

    if (dedupKey) {
      setSessionStorageItem(dedupKey, '1');
    }
  }, []);

  return null;
}
